import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { formatUserRoleType, nounPluralize } from "@utils/data-display";
/** List of entity type which can use change role feature */
export let ChangeRoleEntityType = /*#__PURE__*/function (ChangeRoleEntityType) {
  ChangeRoleEntityType["member"] = "member";
  ChangeRoleEntityType["team"] = "team";
  ChangeRoleEntityType["project"] = "project";
  return ChangeRoleEntityType;
}({});

/** Changing role in company */

/** Changing role in project */

/** Changing role in group */

/** Determines the content of bulk dialog and bulk success dialog for changing role */
export function useChangeRoleBulkDialogContent(t0) {
  const $ = _c(43);
  const {
    subjectType,
    newRole,
    entityType: t1
  } = t0;
  const entityType = t1 === undefined ? ChangeRoleEntityType.member : t1;
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  let t2;
  if ($[0] !== numberOfUpdatingItems) {
    t2 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: "this",
      shouldShowCounter: false
    });
    $[0] = numberOfUpdatingItems;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== entityType || $[3] !== numberOfUpdatingItems) {
    t3 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType,
      shouldShowCounter: false
    });
    $[2] = entityType;
    $[3] = numberOfUpdatingItems;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `Change role for ${t2} 
      ${t3}?`;
  let t5;
  if ($[5] !== entityType || $[6] !== numberOfUpdatingItems) {
    t5 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType,
      shouldShowCounter: false
    });
    $[5] = entityType;
    $[6] = numberOfUpdatingItems;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== newRole) {
    t6 = formatUserRoleType(newRole);
    $[8] = newRole;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `When you confirm this action, the following ${t5} 
      will change their current roles to the ${t6} role.`;
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = {
      title: t4,
      description: t7
    };
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== entityType || $[14] !== numberOfUpdatingItems) {
    t9 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType
    });
    $[13] = entityType;
    $[14] = numberOfUpdatingItems;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `Couldn't Change the role for ${numberOfErrors} of ${t9}`;
  let t11;
  if ($[16] !== numberOfUpdatingItems) {
    t11 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: "this",
      shouldShowCounter: false
    });
    $[16] = numberOfUpdatingItems;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== entityType || $[19] !== numberOfUpdatingItems) {
    t12 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType,
      shouldShowCounter: false
    });
    $[18] = entityType;
    $[19] = numberOfUpdatingItems;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== newRole) {
    t13 = formatUserRoleType(newRole);
    $[21] = newRole;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = `The role of ${t11} ${t12} couldn't be changed to ${t13} in this ${subjectType}, check the details and try again.`;
  let t15;
  if ($[23] !== t10 || $[24] !== t14) {
    t15 = {
      title: t10,
      description: t14
    };
    $[23] = t10;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== entityType || $[27] !== t15 || $[28] !== t8) {
    t16 = {
      initial: t8,
      failed: t15,
      confirmButtonText: "change",
      entityType
    };
    $[26] = entityType;
    $[27] = t15;
    $[28] = t8;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const bulkDialogContent = useGetBulkDialogContent(t16);
  let t17;
  if ($[30] !== numberOfSuccess) {
    t17 = nounPluralize({
      counter: numberOfSuccess,
      word: "role"
    });
    $[30] = numberOfSuccess;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = `${t17} changed`;
  let t19;
  if ($[32] !== entityType || $[33] !== numberOfUpdatingItems) {
    t19 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: entityType,
      shouldShowCounter: false
    });
    $[32] = entityType;
    $[33] = numberOfUpdatingItems;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== newRole) {
    t20 = formatUserRoleType(newRole);
    $[35] = newRole;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = `All selected ${t19} have changed their roles to ${t20}.`;
  let t22;
  if ($[37] !== t18 || $[38] !== t21) {
    t22 = {
      title: t18,
      description: t21
    };
    $[37] = t18;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const successDialogContent = t22;
  let t23;
  if ($[40] !== bulkDialogContent || $[41] !== successDialogContent) {
    t23 = {
      bulkDialogContent,
      successDialogContent
    };
    $[40] = bulkDialogContent;
    $[41] = successDialogContent;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
}